import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Signin.css";
import axios from 'axios';
import Google from "../../assets/google.png";
import Header from "../Header/Header";
import {
  createUserWithEmailAndPassword,
  updateProfile,
  sendPasswordResetEmail,
  sendEmailVerification,
  fetchSignInMethodsForEmail,
  signOut,
} from "firebase/auth";
import { auth } from "../../firebase";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UserContext from "../../UserContext";

const Signin = () => {
  const [isSignin, setIsSignIn] = useState(true);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [selectedOption, setSelectedOption] = useState('customer');
  const [ForgotPassword, setForgotPassword] = useState(false);
  const [verify, setVerify] = useState(false);
  // const [loggedUser,setLoggedUser] = useState();
  const { signIn, userInfo, error, SignInWithGoogle,setError } =
    useContext(UserContext);

  const navigate = useNavigate();

  const navigateSignUp = () => {
    setIsSignIn(false);
    setEmail("");
    setPassword("");
    setName("");
  };

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const sendVerificationEmail = () => {
    if (userInfo) {
      sendEmailVerification(userInfo)
        .then(() => {
          toast.success("Email verification sent");
          setVerify(false);
          setIsSignIn(true);
        })
        .catch((err) => {
          toast.error(`Error sending email verification: ${err}`);
        });
    }
  };

  const handleSignUpButton = async () => {
    if (password === confirmPassword) {
      try {
        const userDetails = await createUserWithEmailAndPassword(
          auth,
          email,
          password
        );

        await updateProfile(auth.currentUser, {
          displayName: name,
          emailVerified: false,
        }).catch((err) => console.log(err));

        const body = {
          displayName: name,
          email: email,
          role: selectedOption
        }

        const response = await axios.post('https://event-finder12.onrender.com/users/createuser', body);

        const resolveAfter3Sec = new Promise((resolve) => {
          setTimeout(() => {
            resolve();
          }, 2000);
        });

        toast.promise(resolveAfter3Sec, {
          pending: "Registering",
          success: "Registration Successful 👌",
          error: "An error occurred with the registration 🤯",
        });


        setVerify(true);
      } catch (err) {
        console.log(err.message);
        toast.error(err.message);
      }
    } else {
      toast.error("Passwords do not match each other");
    }
  };

  const handleSignInButton = () => {
    signIn({ email, password });
  };

  const checkRole = async (id) => {
    try {
      const user = await axios.get(`https://event-finder12.onrender.com/users/getuser/${id}`);
      return user.data.role;
    } catch (err) {
      console.log(err);
    }
  }


  useEffect(() => {
    if (userInfo !== null && isSignin && userInfo.emailVerified) {
      const resolveAfter3Sec = new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 2000);
      });

      toast.promise(resolveAfter3Sec, {
        pending: "Logging in...",
        success: "Login Successful 👌",
        error: "An error occurred with the registration 🤯",
      });

      console.log("Login in after register");
      
      setTimeout( () => {
        checkRole(userInfo.email).then((res)=>{
          if(res==='customer')
          navigate("/dashboard");
        else if(res==='organizer')
          navigate('/admin-dashboard');
        else 
          navigate('/admin-panel')
        }).catch((err)=> {
          console.log("error occured in role finding")
        })
       
      }, 4000);
    } else if (error !== null) {
      const rejectAfter3Sec = new Promise((resolve, reject) => {
        setTimeout(() => {
          reject();
        }, 3000);
      });

      let errorMessage = "Error in signing in. Try Again! 🤯"; 

    if (error.code === "auth/user-disabled") {
      errorMessage = "Your account has been disabled. Please contact support.";
    } else if (error.message) {
      errorMessage = `Error in signing in: ${error.message}`;
    }

      toast.promise(rejectAfter3Sec, {
        pending: "Logging in...",
        success: "Login Successful 👌",
        error: errorMessage,
      });

      console.log(error);
    } else if (userInfo !== null && isSignin && !userInfo.emailVerified) {
      toast.error("Please verify your email");
    }
  }, [userInfo,error]);

  const handleEmailInput = (e) => {
    setEmail(() => e.target.value);
  };

  const handlePasswordInput = (e) => {
    setPassword(() => e.target.value);
  };

  const handleNameInput = (e) => {
    setName(() => e.target.value);
  };

  const handleConfirmPassword = (e) => {
    setConfirmPassword(() => e.target.value);
  };

  const navigateSignIn = () => {
    setIsSignIn(true);
    setForgotPassword(false);
    setEmail("");
    setPassword("");
    setName("");
  };

  const handleGoogleLogin = async () => {
   await SignInWithGoogle();
  };

  const handleForgotPassword = () => {
    setForgotPassword(true);
    setIsSignIn(false);
  };

  const isEmailVerified = async (email) => {
    const user = await fetchSignInMethodsForEmail(auth, email);
    return user && user.length > 0;
  };

  const handlePasswordReset = async () => {
    if (email.length === 0) {
      toast.error("Please enter your registered email address");
    } else {
      try {
        const methods = await fetchSignInMethodsForEmail(auth, email);
        if (methods && methods.length > 0) {
          const isVerified = await isEmailVerified(email);
          console.log(isVerified);
          if (isVerified) {
            await sendPasswordResetEmail(auth, email);
            toast.success("Password Reset Email Sent");
          } else {
            toast.error("Email is not verified");
          }
        } else {
          toast.error("Email does not exist");
        }
      } catch (error) {
        toast.error("Error checking email existence:", error);
        console.log(error);
      }
    }
  };

  return (
    <div className="signin-outer-container">
      <ToastContainer />

      <div className="header-container">
        <Header />
      </div>

      <div className="signin-container">
        {isSignin && !ForgotPassword && !verify ? (
          <>
            <div className="signin-container-header">
              <div className="signin-headtags">
                <h4>Welcome to Event Finder</h4>
                <h1>Login</h1>
              </div>
              <div className="signin-head-link">
                <h5>No Account ?</h5>
                <h5 onClick={navigateSignUp} className="signup-button">
                  Register
                </h5>
              </div>
            </div>
            <div className="signin-forms">
              <div className="signin-form">
                <p className="input-label">Enter your email address</p>
                <input
                  value={email}
                  onChange={handleEmailInput}
                  className="input-field"
                  type="email"
                />
              </div>
              <div className="signin-form">
                <p className="input-label">Enter your password</p>
                <input
                  value={password}
                  onChange={handlePasswordInput}
                  className="input-field"
                  type="password"
                />
                <p onClick={handleForgotPassword} className="forgot-password">
                  Forgot password
                </p>
              </div>
              <div onClick={handleSignInButton} className="signin-button">
                <p>Login</p>
              </div>
              <p>OR</p>
              <div className="signin-socials">
                <div onClick={handleGoogleLogin} className="google-login">
                  {" "}
                  Login with <img className="social-icon" src={Google} />
                </div>
              </div>
            </div>
          </>
        ) : !isSignin && !ForgotPassword && !verify ? (
          <>
            <div className="signin-container-header">
              <div className="signin-headtags">
                <h4>Welcome to Event Finder</h4>
                <h1>Register</h1>
              </div>
              <div className="signin-head-link">
                <h5>Have an Account ?</h5>
                <h5 onClick={navigateSignIn} className="signup-button">
                  Login
                </h5>
              </div>
            </div>
            <div className="signin-forms">
              <div className="signin-form">
                <p className="input-label">{selectedOption==='customer'? 'Enter your full name' : 'Enter Organizer name'}</p>
                <input
                  value={name}
                  onChange={(e) => handleNameInput(e)}
                  className="input-field"
                  type="text"
                />
              </div>
              <div className="signin-form">
                <p className="input-label">Enter your email address</p>
                <input
                  value={email}
                  onChange={(e) => handleEmailInput(e)}
                  className="input-field"
                  type="email"
                />
              </div>
              <div className="signin-form">
                <p className="input-label">Enter your password</p>
                <input
                  value={password}
                  onChange={(e) => handlePasswordInput(e)}
                  className="input-field"
                  type="password"
                />
              </div>
              <div className="signin-form">
                <p className="input-label">Confirm your password</p>
                <input
                  onChange={(e) => handleConfirmPassword(e)}
                  className="input-field"
                  type="password"
                />
              </div>
              <div className="signin-form">
                <p className="input-label">Role</p>
                <select className="role-options" value={selectedOption} onChange={handleSelectChange}>
                  <option value="customer">Customer</option>
                  <option value="organizer">Event Organizer</option>
                </select>
              </div>
              <div
                onClick={handleSignUpButton}
                className="signin-button signup"
              >
                <p>Register</p>
              </div>
            </div>
          </>
        ) : ForgotPassword && !verify ? (
          <>
            <div className="signin-container-header">
              <div className="signin-headtags">
                <h4>Event Finder</h4>
                <h1 className="reset-forgot">Forgot Password</h1>
              </div>
              <div className="signin-head-link reset">
                <h5>Have an Account ?</h5>
                <h5 onClick={navigateSignIn} className="signup-button">
                  Login
                </h5>
              </div>
            </div>
            <div className="signin-forms">
              <div className="signin-form">
                <p className="input-label reset-password">
                  Enter your email address
                </p>
                <input
                  value={email}
                  onChange={handleEmailInput}
                  className="input-field"
                  type="email"
                />
              </div>

              <div
                onClick={handlePasswordReset}
                className="signin-button reset-password"
              >
                <p>Send Reset Email </p>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="signin-container-header">
              <div className="signin-headtags">
                <h4>Event Finder</h4>
                <h1 className="reset-forgot">Email Confirmation</h1>
              </div>
            </div>
            <div className="signin-forms">
              <div
                onClick={sendVerificationEmail}
                className="signin-button reset-password"
              >
                <p>Send Email Confirmation </p>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Signin;
